export function resolvePersistedFileName(localFile, existingFileName) {
  return localFile?.name || existingFileName || null;
}

export function shouldApplyFetchedContractFile({ aborted, userAlreadySelected }) {
  return !aborted && !userAlreadySelected;
}
